(() => {
  const root = document.documentElement;
  const storageKey = 'trainbot-color-mode';
  const assetMap = window.TrainBotThemeAssets || {};

  const storedMode = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'dark' ? 'dark' : 'light';
    } catch (_error) {
      return 'light';
    }
  };

  const findAssetKey = (value) => {
    if (!value) return null;

    let decodedValue = value;
    try {
      decodedValue = decodeURIComponent(value);
    } catch (_error) {
      // The original value is still safe to compare when decoding fails.
    }

    return Object.keys(assetMap).find((key) => decodedValue.includes(key)) || null;
  };

  const restorePictureSources = (image) => {
    const picture = image.closest('picture');
    if (!picture) return;

    picture.querySelectorAll('source[data-tb-theme-original-srcset]').forEach((source) => {
      source.setAttribute('srcset', source.dataset.tbThemeOriginalSrcset);
      source.removeAttribute('data-tb-theme-original-srcset');
    });
  };

  const useDarkImage = (image) => {
    if (!image.dataset.tbThemeAssetKey) return;

    if (image.dataset.tbThemeOriginalSrc) {
      image.setAttribute('src', image.dataset.tbThemeOriginalSrc);
    }
    if (image.dataset.tbThemeOriginalSrcset) {
      image.setAttribute('srcset', image.dataset.tbThemeOriginalSrcset);
    } else {
      image.removeAttribute('srcset');
    }
    if (image.dataset.tbThemeOriginalSizes) {
      image.setAttribute('sizes', image.dataset.tbThemeOriginalSizes);
    } else {
      image.removeAttribute('sizes');
    }

    restorePictureSources(image);
  };

  const useLightImage = (image) => {
    const existingKey = image.dataset.tbThemeAssetKey;
    const candidate = [image.currentSrc, image.getAttribute('src'), image.getAttribute('srcset')].filter(Boolean).join(' ');
    const assetKey = existingKey || findAssetKey(candidate);

    if (!assetKey || !assetMap[assetKey]) return;

    if (!existingKey) {
      image.dataset.tbThemeAssetKey = assetKey;
      image.dataset.tbThemeOriginalSrc = image.getAttribute('src') || '';
      image.dataset.tbThemeOriginalSrcset = image.getAttribute('srcset') || '';
      image.dataset.tbThemeOriginalSizes = image.getAttribute('sizes') || '';

      const picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source[srcset]').forEach((source) => {
          source.dataset.tbThemeOriginalSrcset = source.getAttribute('srcset') || '';
          source.removeAttribute('srcset');
        });
      }
    }

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', assetMap[assetKey]);
  };

  const syncImages = (scope = document) => {
    const mode = root.dataset.colorMode === 'dark' ? 'dark' : 'light';
    const images = [];

    if (scope instanceof HTMLImageElement) images.push(scope);
    if (scope.querySelectorAll) images.push(...scope.querySelectorAll('img'));

    images.forEach(mode === 'light' ? useLightImage : useDarkImage);
  };

  const syncControls = () => {
    const isDark = root.dataset.colorMode === 'dark';

    document.querySelectorAll('[data-theme-toggle]').forEach((control) => {
      const label = isDark ? control.dataset.labelLight : control.dataset.labelDark;
      control.setAttribute('aria-pressed', String(isDark));
      control.setAttribute('aria-label', label);
      control.title = label;

      const labelNode = control.querySelector('[data-theme-toggle-label]');
      if (labelNode) labelNode.textContent = label;
    });
  };

  const applyMode = (mode, persist = false) => {
    const nextMode = mode === 'dark' ? 'dark' : 'light';
    root.dataset.colorMode = nextMode;
    root.style.colorScheme = nextMode;

    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.setAttribute('content', nextMode === 'dark' ? '#000000' : '#f7f6f1');

    if (persist) {
      try {
        window.localStorage.setItem(storageKey, nextMode);
      } catch (_error) {
        // The selected mode still applies when storage is unavailable.
      }
    }

    syncControls();
    syncImages();
  };

  root.addEventListener('click', (event) => {
    const control = event.target.closest('[data-theme-toggle]');
    if (!control) return;

    applyMode(root.dataset.colorMode === 'dark' ? 'light' : 'dark', true);
  });

  const observer = new MutationObserver((mutations) => {
    let addedControls = false;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        syncImages(node);
        if (node.matches?.('[data-theme-toggle]') || node.querySelector?.('[data-theme-toggle]')) {
          addedControls = true;
        }
      });
    });
    if (addedControls) syncControls();
  });

  observer.observe(root, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => {
    syncImages(event.target);
    syncControls();
  });
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) applyMode(storedMode());
  });

  applyMode(storedMode());
})();
